import FileItem from './FileItem'
import { useState, useEffect } from 'react'
import Lightbox from 'yet-another-react-lightbox'
import { Button } from '@/components/ui/button'
import 'yet-another-react-lightbox/styles.css'

const FilesList = ({ files, removeFile, handleUpload, state, handleCancelAll, handleCancel, footer }) => {
    const [title, setTitle] = useState('')
    const [showImage, setShowImage] = useState(false)
    const [imageUrl, setImageUrl] = useState('')

    useEffect(() => {
        const titles = {
            initial: 'Files Uploaded',
            dirty: 'Ready for Uploading',
            uploading: 'Uploading...',
            clean: 'Files Uploaded',
        }

        setTitle(titles[state])
    }, [state])

    const handleShowImage = (url) => {
        setImageUrl(url)
        setShowImage(true)
    }

    return (
        <div>
            {files.length !== 0 && (
                <div
                    style={{
                        marginTop: 16,
                        backgroundColor: '#17273C',
                        padding: '16px 24px',
                        borderRadius: 2,
                    }}
                >
                    <h5 className="mb-3 fw-semibold" style={{ fontSize: 16, marginTop: 20 }}>
                        {title}
                    </h5>
                    <div className="mt-2">
                        {files.map((file) => (
                            <div key={file.id}>
                                <FileItem
                                    file={file}
                                    removeFile={removeFile}
                                    showImage={handleShowImage}
                                    handleCancel={handleCancel}
                                />
                            </div>
                        ))}
                    </div>

                    <Lightbox
                        slides={[{ src: imageUrl }]}
                        index={0}
                        open={showImage}
                        close={() => setShowImage(false)}
                        render={{
                            buttonPrev: () => null,
                            buttonNext: () => null,
                        }}
                        styles={{
                            container: {
                                backgroundColor: 'rgba(0, 0, 0, .8)',
                                backdropFilter: 'blur(3px)',
                            },
                        }}
                    />
                </div>
            )}
            <div className="tw:flex tw:gap-4">
                {state === 'uploading' && (
                    <Button variant="destructiveSoft" onClick={handleCancelAll} className="mt-4">
                        Cancel All
                    </Button>
                )}
                {state === 'dirty' && (
                    <Button className="mt-4 tw:ml-2" onClick={handleUpload} disabled={files.length === 0}>
                        Upload
                    </Button>
                )}
                {state !== 'uploading' && footer}
            </div>
        </div>
    )
}

export default FilesList
